import { TPagination } from "@custom-types/sorting";

export type TAccountManagersPaginated = TPagination & {
  data: Array<AccountManagerModel>;
};

export interface AccountManagerModel {
  id: string;
  lastName: string;
  firstLetters: string;
  lastNamePrefix: string;
  deactivationDateUtc: string;
  isDeactivated: boolean;
  version: string;
}

export class AccountManager implements AccountManagerModel {
  id = "";
  lastName = "";
  firstLetters = "";
  lastNamePrefix = "";
  deactivationDateUtc = "";
  isDeactivated = false;
  version = "";

  constructor(dto?: AccountManagerModel) {
    if (!dto) {
      return;
    }
    Object.assign(this, dto);
  }
}
